// extracted by mini-css-extract-plugin
module.exports = {"Trending":"Trending_SD2xd","Header":"Header_3ITR0","Box":"Box_3JLeL","homePage":"homePage_HM6-h"};